import { render, staticRenderFns } from "./EmbeddedBuilderView.vue?vue&type=template&id=4a0400a6&scoped=true&"
import script from "./EmbeddedBuilderView.vue?vue&type=script&lang=js&"
export * from "./EmbeddedBuilderView.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedBuilderView.vue?vue&type=style&index=0&id=4a0400a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0400a6",
  null
  
)

export default component.exports